import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./epson_barcode_format.js";
//#region src/epson_barcode_format_helper.ts
var epson_barcode_format_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(barcodeFormat) {
	switch (barcodeFormat) {
		case 0: return "UPC A";
		case 1: return "UPC E";
		case 2: return "EAN13";
		case 3: return "JAN13";
		case 4: return "EAN8";
		case 5: return "JAN8";
		case 10: return "CODE128";
	}
}
//#endregion
export { epson_barcode_format_helper_exports, name };

//# sourceMappingURL=epson_barcode_format_helper.js.map